var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{style:({width: _vm.width}),attrs:{"size":_vm.size,"placeholder":_vm.placeholder,"disabled":_vm.disabled},on:{"change":_vm.handleChange},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }